import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, exhaustMap, tap } from 'rxjs';
import { KundeTokenService, StorageService } from '@comparit/infrastructure';
import { TaskContextService } from '@comparit/shared';
import { KfzRoutes } from '../app/app.routes.paths';
import { KundeLoginResponse } from '@comparit/common-api';
import { KundeLoginDialogService } from './kunde-login-dialog.service';

@Injectable({ providedIn: 'root' })
export class KundeLogoutPromptService {
  private readonly kundeToken = inject(KundeTokenService);
  private readonly loginDialog = inject(KundeLoginDialogService);
  private readonly taskContext = inject(TaskContextService);
  private readonly storage = inject(StorageService);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  watch(): void {
    this.kundeToken.loggedOutElsewhere$
      .pipe(
        exhaustMap(kunde => this.prompt(kunde)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private prompt(kunde: string | null): Observable<KundeLoginResponse | null> {
    return this.loginDialog
      .open({ taskId: this.taskContext.taskId(), taskToken: null, taskData: null, mode: 'gated' })
      .pipe(
        tap(response => {
          if (!response && !this.isBackFor(kunde)) this.wipe();
        })
      );
  }

  private isBackFor(kunde: string | null): boolean {
    return kunde !== null && this.kundeToken.externeKundenId() === kunde;
  }

  private wipe(): void {
    this.taskContext.clear();
    this.storage.clearAll();
    this.document.location.replace(KfzRoutes.formular);
  }
}
